'use client';

import { c as _c } from "react/compiler-runtime";
import { useSelector } from '@legendapp/state/react';
import { useQuery } from '@tanstack/react-query';
import type { DetailedHTMLProps, HTMLAttributes } from 'react';
import { AnimatePresence } from 'framer-motion';
import { FleetCategoryTeaser } from '@/components/FleetCategoryTeaser';
import { ReactiveMotionDiv } from '@/components/ReactiveMotionDiv';
import { cn } from '@/lib/cn';
import { getFleetCategoriesOptions, listSitesOptions } from '@/services/rental-api-client';
import { useTestimonialsBlockState } from './TestimonialsBlockProvider';
export type TestimonialFleetCategoryTeaserProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
export function TestimonialFleetCategoryTeaser(t0) {
  const $ = _c(23);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const {
    cardState$
  } = useTestimonialsBlockState();
  const {
    location: reviewLocation,
    fleetCategory: reviewFleetCat,
    id
  } = useSelector(() => cardState$.getActiveItem()) ?? {};
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getFleetCategoriesOptions();
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: fleeTypeData,
    error: fleeTypesError
  } = useQuery(t1);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = listSitesOptions();
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: siteData,
    error: sitesError
  } = useQuery(t2);
  const error = fleeTypesError || sitesError;
  if (error) {
    throw error;
  }
  let t3;
  if ($[5] !== reviewLocation?.code || $[6] !== siteData) {
    t3 = siteData?.find(l => l.siteCode === reviewLocation?.code);
    $[5] = reviewLocation?.code;
    $[6] = siteData;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const location = t3;
  let t4;
  if ($[8] !== fleeTypeData || $[9] !== location?.countryCode || $[10] !== reviewFleetCat?.code) {
    t4 = fleeTypeData?.find(fc => fc.code === reviewFleetCat?.code && fc.region === location?.countryCode);
    $[8] = fleeTypeData;
    $[9] = location?.countryCode;
    $[10] = reviewFleetCat?.code;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const fleetCategory = t4;
  let t5;
  if ($[12] !== className) {
    t5 = cn("h-17 md:h-22 box-content relative flex justify-center items-center mb-6", className);
    $[12] = className;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== fleetCategory || $[15] !== id) {
    t6 = fleetCategory ? <ReactiveMotionDiv key={`fleet-category-${fleetCategory?.code}-${id}`} className="absolute" initial={{
      opacity: 0,
      scale: 0
    }} animate={{
      opacity: 1,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0
    }}>{fleetCategory ? <FleetCategoryTeaser fleetCategory={fleetCategory} /> : null}</ReactiveMotionDiv> : null;
    $[14] = fleetCategory;
    $[15] = id;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t6) {
    t7 = <AnimatePresence>{t6}</AnimatePresence>;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== props || $[20] !== t5 || $[21] !== t7) {
    t8 = <div className={t5} {...props}>{t7}</div>;
    $[19] = props;
    $[20] = t5;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}